export default {
  /**
   * トライアル推移向け期間条件フォーマット
   *
   * 週 / 月 どれが選択されているか、と開始・終了日を保持します。
   * 期間の種別が週・月であっても、最終的な開始・終了の日付で管理します。
   */
  get() {
    return {
      /**
       * 期間種別（週:w / 月:m）
       */
      termType: 'w',
      /**
       * 開始日
       */
      dateFrom: undefined,
      /**
       * 終了日
       */
      dateTo: undefined,
      /**
       * 入力エラー
       */
      errors: [],
    }
  },
  /**
   * 分析APIで使用する期間のフォーマットに変換する
   */
  mapToApiPayload(term) {
    return {
      termType: term.termType,
      dateFrom: term.dateFrom,
      dateTo: term.dateTo,
    }
  },
  /**
   * applyToに対してtermを適用する
   */
  applyPayload(applyTo, term) {
    // Tigerパターンに対して画面遷移することはないので、適用処理は必ず
    // このモデル形式をこのモデル形式に当てはめるだけ。
    applyTo.termType = term.termType
    applyTo.dateFrom = term.dateFrom
    applyTo.dateTo = term.dateTo
  },
}
